import i18next from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import resources from './locales';

const i18n = i18next
  .use(detector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'tr',
    whitelist: ['en', 'tr'],
    nonExplicitWhitelist: true,
    debug: process.env !== 'production',
    resources,
    react: {
      wait: true,
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
